import React from 'react'

function ButtonShowRed() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="#FF8686" />
      <path
        d="M9.80643 16.4409C10.0414 16.6759 10.4203 16.6759 10.6554 16.4409L14.641 12.4553C14.828 12.2683 14.828 11.9661 14.641 11.7791L10.6553 7.79345C10.4203 7.55843 10.0414 7.55843 9.80643 7.79345C9.57142 8.02846 9.57142 8.40736 9.80643 8.64237L13.2789 12.1196L9.80163 15.5968C9.57142 15.827 9.57142 16.2107 9.80643 16.4409Z"
        fill="white"
      />
    </svg>
  )
}

export default React.memo(ButtonShowRed)
